export default {
    byVideo(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('videoId', id).get()
            )
        )
    }
}
